import { useDictionary } from '@adamlip/okeoke.client';
import { Button, Tab, Tabs } from '@nextui-org/react';
import { AppParamsContext } from 'contexts/AppParamsContext';
import { UserContext } from 'contexts/UserContext';
import { useContext, useEffect, useState } from 'react';
import AchCard from 'views/Achievements/AchCard';
import Login from 'views/Login';

function Achievements() {

  const { appParams } = useContext(AppParamsContext);

  const { isVipBrand, userLoggedIn, getVipAchievements } = useContext(UserContext);
  const { getValue } = useDictionary();
  const [loginModal, setLoginModal] = useState(false);
  const [userAchievements, setUserAchievements] = useState(null);
  //const [stampsAchievements, setStampsAchievements] = useState(null);
  const fetchAch = () => {
    getVipAchievements()
      ?.then((res) => {
        if (res?.success) {
          let data = res?.data;
          setUserAchievements(data);
          //let stamps = data?.filter((item) => item?.stampsNeeded);
          //setStampsAchievements(stamps);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchAch();
    //eslint-disable-next-line
  }, []);

  if (!userLoggedIn) {
    return (
      <div className='flex flex-col gap-2 items-center justify-center h-full w-full max-w-[95%] mx-auto  relative overflow-y-scroll pb-[50%]'>
        <div className='w-full text-center text-xl font-bold'>{getValue('app_v2_youAreNotLoggedIn')}</div>
        <div className='w-full text-center mb-4'>{getValue('app_v2_youAreNotLoggedIn_desc')}</div>
        <Button color='primary' onPress={() => setLoginModal(true)}>
          {getValue('app_v2_login')}
        </Button>
        {loginModal && <Login isOpen={loginModal} setIsOpen={setLoginModal} />}
      </div>
    );
  }

  if (!isVipBrand)
    return (
      <div className='flex flex-col gap-2 items-center justify-center h-full w-full  relative overflow-y-scroll pb-[50%]'>
        <div className=''>{getValue('vip.not.available')}</div>
        <Button color='primary' onPress={() => window.location.reload()}>
          {getValue('vip.reload')}
        </Button>
      </div>
    );
  return (
    <div className={`flex flex-col grow gap-2 items-center h-full w-full pt-2 relative overflow-hidden  ${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''}`}>
      <div className='font-bold text-2xl'>{getValue('ach.title')}</div>
      <div className='grow  w-[90%] overflow-y-auto flex flex-col gap-2'>
        <Tabs
          fullWidth
          classNames={{
            panel: 'flex flex-col gap-2 overflow-y-auto pb-32',
          }}>
          <Tab key={'all'} title={getValue('ach.all')}>
            {userAchievements?.map((item, index) => {
              return <AchCard ach={item} key={index} />;
            })}
          </Tab>
          <Tab key={'reached'} title={getValue('ach.reached')}>
            {userAchievements
              ?.filter((item) => item?.userAchievements?.length && item?.userAchievements?.length > 0)
              .map((item, index) => {
                return <AchCard ach={item} key={index} />;
              })}
          </Tab>
          <Tab key={'unreached'} title={getValue('ach.unreached')}>
            {userAchievements
              ?.filter((item) => !item?.userAchievements?.length || item?.userAchievements?.length === 0)
              .map((item, index) => {
                return <AchCard ach={item} key={index} />;
              })}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default Achievements;
